import { Produto } from "../../model/product";

export class SubscriptionFilter{
    planIDs?:number[];
    type?: string[];
    status?: string[];
    start?:Date;
    end?:Date;

}